// GET all coating pumphouse records
export const GET_ALL_COATING_PUMPHOUSE         = '@@get_All_Coating_Pumphouse';
export const GET_ALL_COATING_PUMPHOUSE_SUCCESS = '@@get_All_Coating_Pumphouse_Success';
export const GET_ALL_COATING_PUMPHOUSE_FAILURE = '@@get_All_Coating_Pumphouse_Failure';
export const CLEAR_COATING_PUMPHOUSE_DATA      = '@@clear_Coating_Pumphouse_Data';

// POST bulk create / update
export const BULK_SAVE_COATING_PUMPHOUSE         = '@@bulk_Save_Coating_Pumphouse';
export const BULK_SAVE_COATING_PUMPHOUSE_SUCCESS = '@@bulk_Save_Coating_Pumphouse_Success';
export const BULK_SAVE_COATING_PUMPHOUSE_FAILURE = '@@bulk_Save_Coating_Pumphouse_Failure';
export const CLEAR_BULK_SAVE_COATING_PUMPHOUSE   = '@@clear_Bulk_Save_Coating_Pumphouse';

/** POST savePumpHouseLimitConfig — user-scoped UI config (limits, table prefs, …). */
export const SAVE_PUMP_HOUSE_LIMIT_CONFIG          = '@@save_Pump_House_Limit_Config';
export const SAVE_PUMP_HOUSE_LIMIT_CONFIG_SUCCESS  = '@@save_Pump_House_Limit_Config_Success';
export const SAVE_PUMP_HOUSE_LIMIT_CONFIG_FAILURE  = '@@save_Pump_House_Limit_Config_Failure';
